import { GetPackageOffersResponse } from '../../../useGetPackageOffersAndFlightOptions';

export type ResponseWithTotalFlightOptions = Pick<
  GetPackageOffersResponse,
  'totalFlightOptions'
>;

export const calculateNumberOfPages = (
  data: ResponseWithTotalFlightOptions[] | undefined,
  pageSize: number,
) => {
  const totalFlightOptions = data?.[0]?.totalFlightOptions;

  if (!totalFlightOptions) return 0;

  return Math.ceil(totalFlightOptions / pageSize);
};
